import { Button, message, Popover } from "antd";
import { CopyOutlined, ReloadOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import constants from "../../constants/constants";
import PASSWORD_WORDS from "../../constants/passwordWords";
const PasswordSuggestion = ({ onPasswordSelect }) => {
	const [passwordSuggestion, setPasswordSuggestion] = useState("");
	const specialChars = ["~", "`", "!", "@", "#", "$", "%", "^", "&", "*", "(", ")", "_", "+", "-", "=", "{", "}", "[", "]", "|", "\\", ":", ";", "\"", "'", "<", ">", ",", ".", "?", "/" ];
	const generatePasswordFromWord = (word) => {
		const specialFromWord =
    specialChars[Math.floor(Math.random() * specialChars.length)];
		const extraSpecial =
    specialChars[Math.floor(Math.random() * specialChars.length)];
		const replacedWord = word.replace("-", specialFromWord);
		const formattedWord =
    replacedWord.charAt(0).toUpperCase() +
    replacedWord.slice(1).toLowerCase();
		const numbers = Math.floor(1000 + Math.random() * 9000);
		return `${formattedWord}${extraSpecial}${numbers}`;
	};
	const generateSuggestions = () => {
		const word =
		PASSWORD_WORDS[Math.floor(Math.random() * PASSWORD_WORDS.length)];
		setPasswordSuggestion(generatePasswordFromWord(word));
	};
	useEffect(() => {
		generateSuggestions();
	}, []);
	const handleCopyToClipboard = async (data) => {
		try {
			await navigator.clipboard.writeText(data);
			message.success('Copied to clipboard');
		} catch (err) {
			message.error('Copy failed');
		}
	};
	const content = (
		<div>
			<h3>{constants.PasswordSuggestion}</h3>
			<div className="password-container">
				<div className="title-container">
					{passwordSuggestion}
				</div>
				<div className="flex-column-center">
					<Button
						type="link"
						size="small"
						onClick={(e) => {
							e.stopPropagation();
							generateSuggestions();
						}}
						className="cyan"
						icon={<ReloadOutlined/>}
					>{constants.AnotherOne}</Button>
					<Button
						type="primary"
						className="btnDb"
						size="small"
						onClick={(e) => {
							e.stopPropagation();
							handleCopyToClipboard(passwordSuggestion);
							if (onPasswordSelect) {
								onPasswordSelect(passwordSuggestion);
							}
						}}
						icon={<CopyOutlined/>}
					>{constants.Copy}</Button>
				</div>
			</div>
			<p className="secondaryText mt-2">{constants.PsdTip}</p>
		</div>
	);
	return (
		<Popover content={content} overlayInnerStyle={{ width: 390 }}>
			<Button type="primary" className="btnDb" size="small">{constants.Suggest}</Button>
		</Popover>
	);
};
export default PasswordSuggestion;